import { React, NavLink, useLocation, logo, Layers, Users, UserRound, Zap, Bot, Bell } from '../../utils/globalImports';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import { ExtendedAccountResponse } from '../../store/types';
import { FolderKey, Languages, Menu, PencilLine } from 'lucide-react';

const subMenuItems = [
  {
    name: 'Token Management',
    path: '/token-management',
    icon: Zap,
    allowedRoles: ['superadmin', 'customeradmin'],
  },
  {
    name: 'Translations',
    path: '/translations',
    icon: Languages,
    allowedRoles: ['SuperAdmin'],
  },
  {
    name: 'Configurations',
    path: '/configurations',
    icon: FolderKey,
    allowedRoles: ['SuperAdmin'],
  },
  {
    name: 'LLM Configurations',
    path: '/llm-configuration',
    icon: Bot,
    allowedRoles: ['superadmin'],
  },
  {
    name: 'Notification Templates',
    path: '/notifications/templates',
    icon: Bell,
    allowedRoles: ['SuperAdmin'],
  },
  {
    name: 'Custom Fields',
    path: '/custom-fields',
    icon: PencilLine,
    allowedRoles: ['SuperAdmin'],
  },
  {
    name: 'Agent State',
    path: '/agent-state',
    icon: Layers,
    allowedRoles: ['SuperAdmin'],
  },
];

interface Props {
  visible: boolean;
  collapsed?: boolean;
  onCollapseToggle?: () => void;
}

const SettingsSidebar: React.FC<Props> = ({ visible, collapsed = false, onCollapseToggle }) => {
  const location = useLocation();
  const auth = useSelector((state: RootState) => state.auth);
  const account = auth.account as ExtendedAccountResponse | null;
  const userRole = (account?.user?.role || account?.role)?.trim().toLowerCase();

  const filteredMenuItems = subMenuItems.filter((item) => {
    if (item.name === 'Configurations' || item.name === 'LLM Configurations') {
      // Only show if SuperAdmin and email domain is vaultiscan.ai
      if (
        userRole === 'superadmin' &&
        account?.email &&
        account?.email.split('@')[1]?.toLowerCase() === 'vaultiscan.ai'
      ) {
        return true;
      }
      return false;
    }
    if (item.allowedRoles && userRole) {
      if (Array.isArray(item.allowedRoles)) {
        return item.allowedRoles.some((r) => r.toLowerCase() === userRole.toLowerCase());
      }
    }
    return true;
  });

  return (
    <div className={`customer-sidebar ${visible ? 'slide-in' : 'slide-out'}${collapsed ? ' collapsed' : ''}`}>
      {/* same header pattern as CustomerSidebar */}
      <div className="sidebar-logo-container">
        {!collapsed && <img src={logo} alt="Logo" className="sidebar-logo" />}
        <button type="button" className="sidebar-collapse-btn" onClick={onCollapseToggle}>
          <Menu size={20} />
        </button>
      </div>

      {filteredMenuItems.map((item) => {
        const to = item.path;
        return (
          <div key={item.name} className="sidebar-item">
            <div className="sidebar-link-with-toggle">
              <NavLink
                to={to}
                // if you ever want exact matching, you can add an "exact" field to items
                className={({ isActive }) => (isActive ? 'sub-active-link' : '')}
              >
                <div className="navlink-content">
                  <item.icon className="sub-sidebar-icon" />
                  {/* label hidden when collapsed */}
                  {!collapsed && <span>{item.name}</span>}
                </div>
              </NavLink>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SettingsSidebar;
